export default __webpack_public_path__ + "assets/images/02d2ceaaf62c32743d046d657626d346.png";